/**
 * Converts RGB color markup to HEX
 *
 * @param {string} rgb - String representing RGB color
 * @return {string}
 */
export default function rgbToHex(rgb) {
  const _rgb = rgb.match(/^rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*/i)
  return _rgb && _rgb.length === 4
    ? '#' +
        ('0' + parseInt(_rgb[1], 10).toString(16)).slice(-2) +
        ('0' + parseInt(_rgb[2], 10).toString(16)).slice(-2) +
        ('0' + parseInt(_rgb[3], 10).toString(16)).slice(-2)
    : ''
}

const decimalToHex = (alpha) => {
  const alphaHex = alpha === 0 ? '00' : Math.round(255 * alpha).toString(16)
  if (alphaHex.length === 1) {
    return `0${alphaHex}`
  }
  return alphaHex
}

export const rgbObjectToHex = (rgb, disableAlpha = true) => {
  return `#${('0' + parseInt(rgb.r, 10).toString(16)).slice(-2)}${(
    '0' + parseInt(rgb.g, 10).toString(16)
  ).slice(-2)}${('0' + parseInt(rgb.b, 10).toString(16)).slice(-2)}${
    disableAlpha || !rgb.a ? '' : decimalToHex(rgb.a)
  }`
}

const isValidHex = (hex) => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex)

const getChunksFromString = (st, chunkSize) =>
  st.match(new RegExp(`.{${chunkSize}}`, 'g'))

const convertHexUnitTo256 = (hexStr) =>
  parseInt(hexStr.repeat(2 / hexStr.length), 16)

const getAlphafloat = (a) => {
  if (typeof a !== 'undefined') {
    return parseFloat((a / 255).toFixed(2))
  }
  return undefined
}

export const hexToRGBA = (hex) => {
  if (!isValidHex(hex)) {
    throw new Error(`Invalid HEX ${hex}`)
  }
  const chunkSize = Math.floor((hex.length - 1) / 3)
  const hexArr = getChunksFromString(hex.slice(1), chunkSize)
  const [r, g, b, a] = hexArr.map(convertHexUnitTo256)
  return {
    r,
    g,
    b,
    a: getAlphafloat(a),
  }
}
